import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-14 text-center">
          <span className="inline-block text-xs uppercase tracking-widest text-foreground-400 mb-4 font-label">
            SEO Articles
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Guide e <span className="text-primary-500">Approfondimenti</span>
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            Articoli originali in italiano per aiutarti a scoprire tutto su Itaobuy Spreadsheet, dalle sneakers allo streetwear, con consigli pratici e guide passo dopo passo.
          </p>
        </div>

        {/* Grid of article cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articleList.map((article, i) => (
            <Link
              key={article.slug}
              to={`/articolo/${article.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200 transition-colors cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-0.5 bg-accent-100 text-accent-800 rounded-full text-[11px] font-medium">
                    Guida
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime} di lettura</span>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1.5 mt-4 text-primary-500 text-sm font-medium">
                  <span>Leggi l'articolo</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}